<template>
  <div
    v-if="show"
    class="trial-banner"
  >
    <i class="info circle icon"></i>
    You currently have <strong>{{ daysRemaining }}</strong> days remaining on your Smardie trial account.
  </div>
</template>

<script>
export default {
  name: 'TrialBanner',
  computed: {
    status() {
      return this.$store.getters['getSubscriptionStatus'];
    },
    daysRemaining() {
      return this.status && this.status.days_remaining != null ? this.status.days_remaining : 0;
    },
    show() {
      if (!this.$store.getters['getHeader']) return false;
      if (!this.$store.getters['user/isAuthenticated']) return false;
      if (this.$store.getters['user/isPlatformAdmin']) return false;
      // Hide only inside the quote builder; show on quotes list and everywhere else
      const path = this.$route && this.$route.path ? this.$route.path : '';
      if (path.startsWith('/quote')) return false;
      return this.daysRemaining > 0;
    }
  }
};
</script>

<style scoped>
.trial-banner {
  width: 100%;
  margin-top: 48px; /* below fixed header */
  padding: 10px 1rem;
  background-color: #E7F5FE;
  color: var(--color-nav-bg);
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  box-sizing: border-box;
}
</style>
